import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18ReportB = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M4.125 1.725c.266 0 .485.198.52.454l.005.071v.953h10.09c.388 0 .633.4.48.738l-.035.066-1.834 2.921 1.834 2.924a.525.525 0 0 1-.369.799l-.075.005-10.091-.001v5.01a.525.525 0 0 1-1.045.071l-.005-.07V2.25c0-.29.235-.525.525-.525m9.666 2.528H4.65v5.352h9.141l-1.504-2.397a.53.53 0 0 1-.04-.482l.04-.076z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18ReportB$1 = Svg18ReportB;

export { Svg18ReportB$1 as default };
